<template>
  <div
    v-if="isVisible"
    class="modal fade show d-block"
    tabindex="-1"
    style="background: rgba(0, 0, 0, 0.5)"
    @click.self="hide"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-dark fs-5">
            {{ modalTitle }}
          </h5>
          <button type="button" class="btn-close" @click="hide"></button>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-12">
              <h5><strong>EVENTO:</strong> {{ event.title }}</h5>
              <p class="text-muted">{{ event.description }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <label class="form-label">
                <strong>{{
                  actionType === 4
                    ? "Motivo de la Observación:"
                    : "Motivo del Rechazo:"
                }}</strong>
                <span v-if="event.obs" class="text-danger"
                  >(Observado previamente)</span
                >
              </label>
              <textarea
                v-model="reviewComment"
                class="form-control"
                rows="5"
                :placeholder="
                  actionType === 4
                    ? 'Describa las observaciones que debe corregir el solicitante...'
                    : 'Explique el por qué se está rechazando este evento...'
                "
                required
              ></textarea>
              <div class="form-text">
                {{
                  actionType === 4
                    ? "Sea específico sobre los cambios requeridos."
                    : "Proporcione una explicación clara del rechazo."
                }}
              </div>
            </div>
          </div>

          <div v-if="actionType === 4" class="mt-3 text-dark">
            <strong>Observación:</strong>
            El evento será devuelto al solicitante para que realice las
            correcciones necesarias.
          </div>

          <div v-if="actionType === 5" class="mt-3">
            <strong>Rechazo:</strong>
            El evento será rechazado. El solicitante deberá crear un nuevo
            evento.
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hide">
            Cancelar
          </button>
          <button
            type="button"
            class="btn"
            :class="actionType === 4 ? 'btn-info' : 'btn-danger'"
            @click="submitReview"
            :disabled="!reviewComment.trim()"
          >
            {{ actionType === 4 ? "Observar" : "Rechazar" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  event: {
    type: Object,
    default: () => ({}),
  },
  actionType: {
    type: Number,
    default: 4,
  },
});

const emit = defineEmits(["reviewSubmitted"]);

const isVisible = ref(false);
const reviewComment = ref("");

const modalTitle = computed(() => {
  return props.actionType === 4 ? "OBSERVAR EVENTO" : "RECHAZAR EVENTO";
});

const submitReview = () => {
  if (!reviewComment.value.trim()) {
    return;
  }

  const obsData = {
    event: props.event,
    actionType: props.actionType,
    comment: reviewComment.value.trim(),
  };

  emit("reviewSubmitted", obsData);

  reviewComment.value = "";
  hide();
};

const show = () => {
  reviewComment.value = props.event.obs || "";
  isVisible.value = true;
  document.body.style.overflow = "hidden";
};

const hide = () => {
  isVisible.value = false;
  document.body.style.overflow = "";
  reviewComment.value = "";
};

defineExpose({
  show,
  hide,
});
</script>
